import React from "react";
import { capitalize } from "lodash";
import { Tag } from "antd";
import { replaceSubstring } from "../utils";
import { TEMPLATE_TYPES } from "./TemplateConstant";

// Alias kept for the email surfaces that already import it. TemplateConstant is
// the single source of truth so the two lists cannot drift.
export const TEMPLATE_ENUMS = TEMPLATE_TYPES;

export const EMAIL_STATUS_ENUMS = Object.freeze({
  QUEUED: "QUEUED",
  SENT: "SENT",
  DELIVERED: "DELIVERED",
  BOUNCE: "BOUNCE",
  COMPLAINT: "COMPLAINT",
  DELIVERY_DELAYED: "DELIVERY DELAYED",
  REJECTED: "REJECTED",
  RENDERING_FAILURE: "RENDERING FAILURE",
  OPENED: "OPENED",
  CLICKED: "CLICKED",
});

export const EMAIL_TYPE_ENUMS = Object.freeze({
  MANUAL: "MANUAL",
  APPOINTMENT: "APPOINTMENT",
  CAMPAIGN: "CAMPAIGN",
});

export const EMAIL_STATUS_TAG_COLORS = Object.freeze({
  QUEUED: "blue",
  SENT: "green",
  DELIVERED: "cyan",
  BOUNCE: "gold",
  COMPLAINT: "magenta",
  DELIVERY_DELAYED: "lime",
  REJECTED: "red",
  RENDERING_FAILURE: "volcano",
  OPENED: "purple",
  CLICKED: "orange",
});

export const renderEmailStatus = status => {
  return (
    <Tag color={EMAIL_STATUS_TAG_COLORS[status]}>
      {capitalize(replaceSubstring(status, "_", " "))}
    </Tag>
  );
};

export const EMAIL_FORWARDING_PREFIX = "Fwd:";
export const EMAIL_REPLY_PREFIX = "Re:";

// Rich Text Editor Constants
export const EDITOR_FONT_SIZES = Object.freeze({
  SMALL: "1",
  NORMAL: "3",
  LARGE: "5",
  HUGE: "7",
});

export const EDITOR_FONT_SIZE_LABELS = Object.freeze({
  [EDITOR_FONT_SIZES.SMALL]: "Small",
  [EDITOR_FONT_SIZES.NORMAL]: "Normal",
  [EDITOR_FONT_SIZES.LARGE]: "Large",
  [EDITOR_FONT_SIZES.HUGE]: "Huge",
});

export const EDITOR_FONT_SIZE_PIXELS = Object.freeze({
  [EDITOR_FONT_SIZES.SMALL]: "12px",
  [EDITOR_FONT_SIZES.NORMAL]: "16px",
  [EDITOR_FONT_SIZES.LARGE]: "20px",
  [EDITOR_FONT_SIZES.HUGE]: "28px",
});

export const EDITOR_COMMANDS = Object.freeze({
  BOLD: "bold",
  ITALIC: "italic",
  UNDERLINE: "underline",
  STRIKETHROUGH: "strikethrough",
  FONT_SIZE: "fontSize",
  CREATE_LINK: "createLink",
  INSERT_HTML: "insertHTML",
  JUSTIFY_LEFT: "justifyLeft",
  JUSTIFY_CENTER: "justifyCenter",
  JUSTIFY_RIGHT: "justifyRight",
  ORDERED_LIST: "insertOrderedList",
  UNORDERED_LIST: "insertUnorderedList",
  FORE_COLOR: "foreColor",
  STYLE_WITH_CSS: "styleWithCSS",
});

export const EDITOR_LINK_ID_PREFIX = "engagedAi-link-";
export const EDITOR_IMAGE_ID_PREFIX = "engagedAi";

// Zero-width space for empty spans
export const ZERO_WIDTH_SPACE = "\u200B";

export const EMAI_STATUS_FILTER = [
  { text: "Delivered", value: "DELIVERED" },
  { text: "Opened", value: "OPENED" },
  { text: "Clicked", value: "CLICKED" },
  { text: "Unsubscribed", value: "UNSUBSCRIBED" },
  { text: "Complaint", value: "COMPLAINT" },
  { text: "Sent", value: "SENT" },
  { text: "Received", value: "RECEIVED" },
  { text: "Bounce", value: "BOUNCE" },
  { text: "Failed", value: "FAILED" },
];
